<template>
  <v-container v-if="this.$store.getters.programsFetched">
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title xs12 sm6>
            <div>
              <h1 class="block-header">{{ $t('message.login.welcome') }}</h1>
              <v-divider></v-divider>
              <p
                class="block-message"
                v-html="
                  $t('message.login.welcomeMessage', {
                    programName: this.$store.getters.getProgramDisplayName
                  })
                "
              ></p>
            </div>
            <v-flex sm8 offset-sm2>
              <v-form v-model="valid" ref="form" lazy-validation>
                <v-text-field
                  label="E-mail"
                  v-model="email"
                  type="email"
                  validate-on-blur
                ></v-text-field>

                <v-text-field
                  label="Password"
                  v-model="password"
                  type="password"
                  :rules="passwordRules"
                  v-on:keyup.enter="submit"
                  validate-on-change
                ></v-text-field>
              </v-form>
            </v-flex>
          </v-card-title>
          <v-layout justify-center>
            <v-card-actions class="button-buffer">
              <v-btn
                block
                class="btn-primary ie-large-btn"
                @click="submit()"
                :disabled="!valid"
                >{{ $t('message.login.login') }}</v-btn
              >
            </v-card-actions>
            <v-card-actions class="button-buffer">
              <router-link to="/register">{{
                $t('message.login.register')
              }}</router-link>
              <router-view></router-view>
            </v-card-actions>
            <v-card-actions class="button-buffer">
              <router-link to="/passwordReset">{{
                $t('message.passwordReset.welcome')
              }}</router-link>
              <router-view></router-view>
            </v-card-actions>
          </v-layout>

          <v-layout justify-center>
            {{$t('message.supportNumberMsg')}}
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Register from './Register'

export default {
  data() {
    return {
      passwordRules: [v => !!v || 'Password is required'],
      valid: false,
      email: '',
      password: '',
      loginToken: this.$route.params.loginToken //only for invited owners that already have accounts
    }
  },
  components: {
    register: Register
  },
  methods: {
    reenter() {
      this.email = ''
    },
    submit() {
      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
        if (this.loginToken) {
          this.ownerLogin();
        } else {
          this.login();
        }
      }
    },
    //called in the unique case where the owner email already had an account
    //when they were invited and we just need to link them to the application
    ownerLogin() {
      axios.post('/api/v1/pub/participant/verifyAccount', {
        email: this.email,
        domain: this.$store.getters.getProgram.domain,
        password1: this.password,
        code: this.loginToken
      })
        .then(response => {
          var authenticatedUser = response.data
          this.$store.commit('setAuthenticatedUser', authenticatedUser)
          this.$router.push('/applicationList')
        })
        .catch(error => {
          this.notifyAxiosError(error, 'Error logging in')
        })
    },
    login() {
      axios.post('/login', {
        email: this.email,
        password1: this.password
      })
        .then(response => {
          var authenticatedUser = response.data
          this.$store.commit('setAuthenticatedUser', authenticatedUser)

          if (authenticatedUser.admin) {
            this.$router.push('/applicationAdminList')
          } else {
            this.$router.push('/applicationList')
          }
        })
        .catch(error => {
          if (error.response && error.response.status == '401') {
            if (error.response.data.message) {
              this.notifyWarn(error.response.data.message)
            } else {
              this.notifyWarn('Login failed. Please try again')
            }
          } else if (error.response && error.response.status == '406') {
            this.notifyWarn(error.response.data)
          } else {
            this.notifyError('There has been a system error. Please contact support.')
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue